import React, {useState, useMemo} from "react";
import AllCouponsContext from "./AllCouponsContext";

const AllCouponsState = (props) => {
  const [state, setState] = useState([]);
  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );
  // console.log("all Categories in state:", state);
  return (
    <AllCouponsContext.Provider value={value}>
      {props.children}
    </AllCouponsContext.Provider>
  );
};

export default AllCouponsState;
